<script lang="ts">
export default {
    name: "leftHeader",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue";
import { store } from '@/store'
import { getCityList, getAreaList, getOrgList,getProductInfo } from "@/api/system/index"

const cityCode = ref()

const cityOptions: any = ref([])

const CityList = () => {
    getCityList().then((res) => {
        cityOptions.value = res.list
    })
}

const areaCode = ref()

const countyOptions: any = ref([])

const AreaList = () => {
    areaCode.value = ""
    provinceCode.value = ""
    const foundObject = cityOptions.value.find((item:any) => item.cityCode == cityCode.value);
    store.informationListStore.informationStore().setCityObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
    getAreaList(cityCode.value).then((res) => {
        countyOptions.value = res.areaList
    })
}

const provinceCode = ref()

const squadronOptions = ref()

const OrgList = () => {
    provinceCode.value = ""
    const params: any = {}
    params.cityCode = cityCode.value
    params.areaCode = areaCode.value
    const foundObject = countyOptions.value.find((item:any) => item.areaCode == areaCode.value);
    store.informationListStore.informationStore().setAreaObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
    getOrgList(params).then((res) => {
        squadronOptions.value = res.list
    })
}
const provinceChange = () => {
    const foundObject = squadronOptions.value.find((item:any) => item.id == provinceCode.value);
    store.informationListStore.informationStore().setorgObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
}

const urlKey = ref()
const title = ref()
onMounted(() => {
    CityList()
    if(localStorage.getItem("cityCode")){
        cityCode.value = localStorage.getItem("cityCode")
    }
    if(localStorage.getItem("areaCode")){
        AreaList()
        areaCode.value = localStorage.getItem("areaCode")
    }
    if(localStorage.getItem("provinceCode")){
        OrgList()
        provinceCode.value = localStorage.getItem("provinceCode")
    }
    if(sessionStorage.getItem("key")){
        urlKey.value = sessionStorage.getItem("key")
        getProductInfo(urlKey.value).then((res)=>{
            title.value = res.productName
        })
    }
})
</script>

<template>
    <div class="left-header">
        <div class="headerBox">
            {{ title }}
            <!-- <img src="@/assets/images/title-big.png" alt="" v-if="urlKey == 'ls'">
            <img src="@/assets/images/qdh-bigtitle.png" alt="" v-else-if="urlKey == 'qdh'">
            <img src="@/assets/images/hzjsc.png" alt="" v-else-if="urlKey == 'hz'"> -->
        </div>
        <div class="selectBox">
            <el-select v-model="cityCode" placeholder="市级" size="large" style="width: 6.25rem;" @change="AreaList()"
                popper-class="select-option" clearable>
                <el-option v-for="item in cityOptions" :key="item.cityCode" :label="item.cityName"
                    :value="item.cityCode" />
            </el-select>
            <el-select v-model="areaCode" placeholder="县级" size="large" style="width: 6.25rem" @change="OrgList()"
                popper-class="select-option" clearable>
                <el-option v-for="item in countyOptions" :key="item.areaCode" :label="item.areaName"
                    :value="item.areaCode" />
            </el-select>
            <el-select v-model="provinceCode" placeholder="中队" size="large" style="width: 10rem"
                @change="provinceChange" popper-class="select-option" clearable>
                <el-option v-for="item in squadronOptions" :key="item.id" :label="item.name"
                    :value="item.id" />
            </el-select>
        </div>
    </div>
</template>

<style lang="scss">
.select-option {
    background-color: rgba(0, 136, 255, 0.5) !important;

    .el-select-dropdown__item {
        color: #fff;
    }

    .el-select-dropdown__item.selected {
        font-size: 14px;
        font-weight: 400;
        background-color: rgba(0, 136, 255, 0.1) !important;
    }

    .el-select-dropdown__item.is-hovering {
        background-color: rgba(0, 136, 255, 0.1) !important;
    }

    .el-popper__arrow:before {
        background-color: rgba(0, 136, 255, 0.1) !important;
    }
}
</style>

<style scoped lang="scss">
.left-header {
    height: 10.2vh;

    .headerBox {
        width: 27.6vw;
        height: 3.3vh;
        font-family: 'DYZG';
        font-size: 36px;
        color: #FFFFFF;
        margin-top: 13px;
        text-align: center;
        text-shadow: 2px 3px 3px rgba(0,0,0,.5);
        img{
            width: 25.375rem;
            height: 2.125rem;
        }
    }

    .selectBox {
        width: 18.5vw;
        margin-left: 0.625rem;
        margin-top: 1.25rem;
        height: 5vh;
        text-align: right;
        display: flex;
        justify-content: space-between;
        align-items: center;

        // margin-top: .5625rem;
        :deep(.el-select) {
            height: 3.2vh;

            .el-select__wrapper {
                min-height: 3.2vh;
                background-color: rgba(0, 0, 0, 0.32);
                border-radius: 5px;
                color: #fff;
            }

            .el-select__placeholder {
                color: #fff;
                font-size: .75rem !important;
            }
        }
    }
}
</style>
